<script lang="ts">
  import SocialIcons from './SocialIcons.svelte';
  import type { Speaker } from './types';
  import dataService from './utils/data-service.svelte';

  type Props = {
    speaker: Speaker;
  }

  const { speaker }: Props = $props();
  const { name, position, business, image, link } = speaker;

  const formattedName = $derived.by(() => {
    if (name.includes(' ')) {
      return name.replace(/\s/, '<br>');
    }
    return name;
  });

  const meta = [];
  const businessData = dataService.getBusiness(business);
  if (position) meta.push(position);
  if (businessData) meta.push(businessData.name);
  const metaStr = meta.join(', ');
</script>

<article class="speaker-tile relative h-full flex flex-col hover:scale-[1.01] focus:scale-[1.01] transition-transform">
  <div class="p-3 bg-white flex flex-col grow">
    <div class="aspect-square relative w-full bg-blue mb-4">
      {#if image}
        <img src={image} alt={name} class="absolute w-full h-full object-cover object-center" />
      {/if}
    </div>
    <div class="copy-block md:min-h-[5.72rem] grow">
      <h1 class="!m-0 text-[1.7em] text-pink">{@html formattedName}</h1>
      <p class="!mt-1 font-bold">{@html metaStr}</p>
    </div>
    {#if businessData?.logo}
      <div class="border-t border-blue pt-3 mt-3">
        <img src={businessData.logo} alt={businessData.name} class="h-12 w-full object-contain object-center" />
      </div>
    {/if}
  </div>
  <div class="relative bg-blue p-3 h-12 [&_a]:relative [&_a]:z-10">
    <SocialIcons links={speaker.social_links} />
  </div>
  <a href={link} class="inset-0 absolute" aria-label={`Link to ${name}`}></a>
</article>